import { Http } from '../../../support';

const initialState = {
  busy: false,
  data: [],
  filters: {
    search: '',
  },
  pagination: {
    limit: 25,
  },
};

const paginate = async (store, meta = {}) => {
  store.setState((state) => {
    state.app.catalogos.moneda = {
      ...state.app.catalogos.moneda,
      filters: {
        ...state.app.catalogos.moneda.filters,
        ...meta,
      },
      busy: true,
    };
  });

  try {
    const { filters, pagination } = store.state.app.catalogos.moneda;

    const params = {
      ...filters,
      ...meta,
      limit: pagination.limit,
      page: meta.page || 1,
    };

    const response = await Http.get('catalogos/moneda', { params });

    store.setState((state) => {
      state.app.catalogos.moneda = {
        ...state.app.catalogos.moneda,
        busy: false,
        data: response.data,
        pagination: {
          ...state.app.catalogos.moneda.pagination,
          ...response.meta.pagination,
          links: undefined,
        },
      };
    });
  } catch (error) {
    store.setState((state) => {
      state.app.catalogos.moneda.busy = false;
      state.app.catalogos.moneda.error = error.data || error;
    });
  }
};

const reset = (store) => {
  store.setState((state) => {
    state.app.catalogos.moneda = {
      ...initialState,
    };
  });
};

const MonedaSuggestionsStore = {
  state: () => initialState,
  actions: {
    paginate,
    reset,
  },
};

export default MonedaSuggestionsStore;
